import styled from 'styled-components';

import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Sections = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    
    & > section[data-test='promo-tab-discounts'] {
        margin-bottom: 36px;
    }

    & > section {
        width: 100%;

        &:nth-child(1) {
            margin-bottom: 52px;
        }
    
        &:nth-child(2) {
            margin-bottom: 80px;
        }
    };

`;

export const Header = styled(H3)`
    margin-top: 63px;
    margin-bottom: 42px;
    ${FONTS.H2};
`;

export const Card = styled.div`
    flex-direction: row;
    max-width: 33%;
    margin-bottom: -30px;
    min-width: 315px;
    @media (max-width: 1185px) {
        max-width: 50%;
    }
    @media (max-width: 706px) {
        max-width: 100%;
    }
`;

export const CardWrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    height: fit-content;
`;
